export class QASAddress {
    public SearchText: string;
    public QASId: string;
    public isFormattedAddress: boolean;
}